import React from "react";
import { useTranslation } from "react-i18next";
import { legendStops, qualityLabelKey } from "../../../utils/road";
import styles from "../../network_map/network_map.module.css";

export default function RoadLegend({ metric }) {
  const { t } = useTranslation();
  const stops = legendStops(metric);
  if (!stops.length) return null;
  return (
    <div className={styles.legend}>
      <div className={styles.legendTitle}>{t(`roadmap.metrics.${metric}`)}</div>
      {stops.map((stop) => (
        <div key={stop.q} className={styles.legendRow}>
          <i className={styles.legendSwatch} style={{ background: stop.color }} />
          <span className={styles.legendLabel}>{t(qualityLabelKey(stop.q * 25))}</span>
          <span className={styles.legendValue}>{stop.label}</span>
        </div>
      ))}
    </div>
  );
}
